import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import Dashboard from "./Components/Dashboard/Dashboard";
import Header from "./Components/Header/Header";
import LoginPage from "./Components/Login/Login";
import Loading from "./Components/Loading";
import Location from "./Components/Location/Location";
import Vendor from "./Components/Vendor/Vendor";
import Document from "./Components/Document/Document";
import { Button } from "@mui/material";
import Copyright from "./Components/Copyright";
import ProtectedRoute from "./ProtectedRoute";
import Staff from "./Components/Staff/Staff";
import { VendorProvider } from "./utils/Context";
import Settings from "./Components/Settings/Settings";
import ActivityTab from "./Components/Settings/ActivityTab";
import Role from "./Components/Role/Role";
import InvoiceDashboard from "./Components/InvoiceDashboard/InvoiceDashboard";
import { getPermissionByPrefix } from "./utils/permissions";
import NotFound from "./Components/NotFound";
import { Navigate } from "react-router-dom";
import ProfilePage from "./Components/ProfilePage/ProfilePage";
import axios from "axios";
import TokenRefreshWarning from "./TokenRefreshWarning";
import DocumentHub from "./Components/DocumentHub/DocumentHub";
import NttDashboard from "./Components/Dashboard/NttDashboard";
import NttDocument from "./Components/NttDocument/NttDocument";
import RemovedServicesDashboard from "./Components/Dashboard/RemovedServicesDashboard";

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
    const navigate = useNavigate();
  const [tokenChecked, setTokenChecked] = useState(false);
  const [showRefreshModal, setShowRefreshModal] = useState(false);

  const dashboardOverview = getPermissionByPrefix("dashboard_overview");
  const creditAchievement = getPermissionByPrefix("credit_achievement");
  const documentPermission = getPermissionByPrefix("manage_document");
  const vendorPermission = getPermissionByPrefix("manage_vendor");
  const staffPermission = getPermissionByPrefix("manage_user");
  const rolePermission = getPermissionByPrefix("manage_roles");
  const locationPermission = getPermissionByPrefix("manage_location");
  const logPermission = getPermissionByPrefix("log_activity");
  const documenthubPermission = getPermissionByPrefix("upload_document");

  const showDashboard =dashboardOverview?.is_view || creditAchievement?.is_view;
  
  const hasSidebarAccess = dashboardOverview?.is_view || creditAchievement?.is_view || staffPermission?.is_view || vendorPermission?.is_view || documentPermission?.is_view || rolePermission?.is_view || locationPermission?.is_view;
const [isSidebarOpen, setSidebarOpen] = useState(!!hasSidebarAccess);

  // const [isSidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
  if (hasSidebarAccess) {
    setSidebarOpen(true);
  } else {
    setSidebarOpen(false);
  }
}, [hasSidebarAccess]);


  const contentStyle =
    location.pathname === "/"  || location.pathname === "/not-found"
      ? {}
      : {
          paddingTop: "70px",
          marginLeft: isSidebarOpen ? "20px" : "0",
          transition: "0.3s",
          paddingLeft: isSidebarOpen ? "220px" : "0px",
        };

  useEffect(() => {

    const validateToken = async () => {
  const token = localStorage.getItem("tokenInv");

  if (!token) {
    navigate("/");
    return;
  }

  try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/api/token/status`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (!res.data?.status) {
      localStorage.removeItem("tokenInv");
      navigate("/");
    } else {
      setTokenChecked(true);

      if (res.data.data?.needs_refresh  && localStorage.getItem("refreshTokenInv")) {
        setShowRefreshModal(true);
      } else {
        setShowRefreshModal(false);
      }
    }
  } catch (error) {
    console.error("Token validation error", error);
    localStorage.removeItem("tokenInv");
    navigate("/");
  }
};

    validateToken();
  }, [location.pathname]);

  return (
    <VendorProvider>
      <div>
        {location.pathname !== "/" && location.pathname !== "/not-found" && (
          <>
            <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <Header toggleSidebar={toggleSidebar} showSidebarToggle={hasSidebarAccess}/>
          </>
        )}

        <div style={contentStyle}>
          <Routes>
            <Route path="/" element={<LoginPage />} />
              {showDashboard && ( <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />)}
              {documentPermission.is_view && ( <Route path="/document" element={<ProtectedRoute element={<Document />} />} />)}
              {documenthubPermission.is_view && (<Route path="/document-hub" element={<ProtectedRoute element={<DocumentHub />} />} />)}
              {locationPermission.is_view && ( <Route path="/location" element={<ProtectedRoute element={<Location />} />} /> )}
              {vendorPermission.is_view && ( <Route path="/vendor" element={<ProtectedRoute element={<Vendor />} />} /> )}
              {staffPermission.is_view && ( <Route path="/employee" element={<ProtectedRoute element={<Staff />} />} /> )}
              {rolePermission.is_view && ( <Route path="/role" element={<ProtectedRoute element={<Role />} />} /> )}
              {logPermission.is_view && ( <Route path="/logs" element={<ProtectedRoute element={<ActivityTab />} />} /> )}
              <Route path="/profile" element={<ProtectedRoute element={<ProfilePage showSidebarToggle={hasSidebarAccess}/>} />} />
              <Route path="/not-found" element={<NotFound />} />
              <Route path="/ntt-dashboard" element={<NttDashboard />} />
              <Route path="/ntt-document" element={<NttDocument />} />
              {showDashboard && ( <Route path="/circuit-dashboard" element={<ProtectedRoute element={<RemovedServicesDashboard />} />} />)}
              {showDashboard && ( <Route path="/invoice" element={<ProtectedRoute element={<InvoiceDashboard />} />} />)}
              <Route path="*" element={<Navigate to="/not-found" />} />
          </Routes>
        </div>

        {/* {location.pathname !== "/" && location.pathname !== "/not-found" && <Copyright />} */}
        <TokenRefreshWarning open={showRefreshModal} onClose={() => setShowRefreshModal(false)} />

      </div>
    </VendorProvider>
  );
};

export default App;
